import { render, staticRenderFns } from "./datagrid.vue?vue&type=template&id=855d2830"
import script from "./datagrid.ts?vue&type=script&lang=js&external"
export * from "./datagrid.ts?vue&type=script&lang=js&external"
import style0 from "./datagrid.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports